import React from 'react'
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import classes from "./BackButton.module.css";

function BackButton() {
    const navigate = useNavigate();
    return (
        <Button
            className={classes.backButton}
            onClick={() => navigate(-1)}
            variant="raised"
            sx={{
                position:'fixed',
                '&:hover': {
                    background: 'none',
                }
            }}
        >
        <ArrowBackIcon
            color="success"
        />
      </Button>
    )
}

export default BackButton
